import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const PrivateRoute = ({ children, roles }) => {
  const { isAuthenticated, primaryRole, user } = useContext(AuthContext);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Enforce Super Admin Master User strict boundaries
  const isOnlySuperAdminAndMaster =
    user?.isMasterUser === true &&
    Array.isArray(user?.role) &&
    user.role.length === 1 &&
    user.role[0] === "superadmin";

  if (isOnlySuperAdminAndMaster) {
    const currentPath = location.pathname.toLowerCase().replace(/\/$/, "");
    if (
      currentPath !== "/superadmin" &&
      currentPath !== "/superadmin/library" &&
      !currentPath.startsWith("/superadmin/library/") &&
      !currentPath.startsWith("/superadmin/library-stats")
    ) {
      return <Navigate to="/superadmin" replace />;
    }
  }

  if (roles && !roles.includes(primaryRole)) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Enforce INDIVIDUAL category strict boundaries
  if (
    user?.category === "INDIVIDUAL" &&
    !location.pathname.startsWith("/individual")
  ) {
    return <Navigate to="/individual" replace />;
  }

  // Enforce UPSC category strict boundaries
  if (user?.category === "UPSC" && !location.pathname.startsWith("/upsc")) {
    return <Navigate to="/upsc" replace />;
  }

  // Prevent non-INDIVIDUAL users from accessing /individual routes
  if (
    user?.category !== "INDIVIDUAL" &&
    location.pathname.startsWith("/individual")
  ) {
    return <Navigate to={primaryRole ? `/${primaryRole}` : "/"} replace />;
  }

  // Prevent non-UPSC users from accessing /upsc routes
  if (user?.category !== "UPSC" && location.pathname.startsWith("/upsc")) {
    return <Navigate to={primaryRole ? `/${primaryRole}` : "/"} replace />;
  }

  return children;
};

export default PrivateRoute;
